import { NgModule } from '@angular/core';
import { LoaderComponent } from './loader.component';
import { MatProgressSpinnerModule } from '@angular/material';

@NgModule({
  declarations: [
    LoaderComponent
  ],
  entryComponents: [
  ],
  imports: [
    MatProgressSpinnerModule
  ],
  exports: [
    LoaderComponent
  ],
  providers: [

  ],
})
export class LoaderModule {
}
